import { Observable } from 'rxjs';

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class ReportsData {
  abstract getSabaudb(params: any): Observable<ApiResponse>;
  abstract getSabaudbAccountSummary(params: any): Observable<ApiResponse>;
}
